<script setup lang="ts">
import { faShoppingCart } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon, TmlBubble, TmlButton, TmlPip } from '@teemill/components';
import { useCartStore } from '@teemill/modules/ecommerce';
import { useRouter } from 'vue-router';

const router = useRouter();
const cart = useCartStore();
</script>

<template>
  <TmlButton class="!rounded-full" @click="router.push({ name: 'resupply.shop' })">
    <TmlPip top="-4px" right="-4px">
      <TmlBubble>
        <FontAwesomeIcon :icon="faShoppingCart" />
      </TmlBubble>
      <template v-if="cart.uniqueItemCount > 0" #pip>
        {{ cart.itemCount }}
      </template>
    </TmlPip>
  </TmlButton>
</template>
